module.exports = __webpack_public_path__ + "assets/img/withdraw-support-fin.9de62224.svg";